import {
  evolve, compose, lensPath,
  set, F, T, always,
  path, pathOr
} from 'ramda';

// Actions
export const workHoursActions = {
  request: 'WORK_HOURS_REQUEST',
  success: 'WORK_HOURS_SUCCESS',
  fail: 'WORK_HOURS_FAIL'
};

export const requestWorkHours = (values) => ({ type: workHoursActions.request, values });

// Selectors
export const WORK_HOURS_EXPORT_FORM = 'WORK_HOURS_EXPORT_FORM';

const getRoot = pathOr({}, ['workHoursExport', 'workHours']);

export const getWorkHoursExportId = compose(path(['id']), getRoot);


// Reducer
const initialState = {
  id: null,
  list: [],
  fetching: false,
  error: false
};

const requestEvolve = {
  fetching: T,
  error: F
};

const failEvolve = (error) => ({
  fetching: F,
  error: always(error)
});

const successEvolve = {
  fetching: F,
  error: F
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case workHoursActions.request: {
      return evolve(requestEvolve, state);
    }
    case workHoursActions.success: {
      const { id, list } = payload;

      const listL = lensPath(['list']);
      const idL = lensPath(['id']);
      return compose(
        evolve(successEvolve),
        set(idL, id),
        set(listL, list)
      )(state);
    }
    case workHoursActions.fail: {
      return evolve(failEvolve(payload), state);
    }
    default:
      return state;
  }
};
